import React from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_ERROR_MESSAGE } from 'constant';
import { AlertComponent } from 'UIElements';
import { isNotEmptyObj } from 'utils';

import './AlertNotifications.scss';

export const blockName = 'alert-notifications';

const AlertNotifications = ({
  alertDetails,
  clearAlertDetails,
  clearCustomError,
  clearGlobalError,
  clearGlobalWarning,
  customError,
  error,
  globalWarning,
}) => (
  <div className={blockName} data-testid={blockName}>
    {isNotEmptyObj(error) && (
      <AlertComponent
        applyTimer={false}
        customMessage={DEFAULT_ERROR_MESSAGE}
        onClose={clearGlobalError}
        severity="error"
      />
    )}
    {Boolean(customError) && (
      <AlertComponent
        applyTimer={false}
        customMessage={customError}
        onClose={clearCustomError}
        severity="error"
      />
    )}
    {globalWarning.trim() !== '' && (
      <AlertComponent
        applyTimer={false}
        customMessage={globalWarning}
        onClose={clearGlobalWarning}
        severity="warning"
      />
    )}
    {alertDetails && alertDetails.display && (
      <div className={`${blockName}__alert`}>
        <AlertComponent
          customMessage={alertDetails?.message}
          customTime={alertDetails?.time}
          onClose={clearAlertDetails}
          severity={alertDetails?.severity}
        />
      </div>
    )}
  </div>
);

AlertNotifications.propTypes = {
  alertDetails: PropTypes.object.isRequired,
  clearAlertDetails: PropTypes.func.isRequired,
  clearCustomError: PropTypes.func.isRequired,
  clearGlobalError: PropTypes.func.isRequired,
  clearGlobalWarning: PropTypes.func.isRequired,
  customError: PropTypes.string.isRequired,
  error: PropTypes.object.isRequired,
  globalWarning: PropTypes.string.isRequired,
};

export default AlertNotifications;
